import { GoogleAuthProvider, getAuth } from 'firebase/auth';
// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import {
  addDoc,
  getFirestore,
  query,
  serverTimestamp,
  collection,
} from 'firebase/firestore';

const firebaseConfig = {
  apiKey: 'AIzaSyB_edPbjZpIFPFO0y-gRbYmJel6F8Ln2Jg',
  authDomain: 'pabraces.firebaseapp.com',
  databaseURL: 'https://pabraces-default-rtdb.firebaseio.com',
  projectId: 'pabraces',
  storageBucket: 'pabraces.appspot.com',
  messagingSenderId: '496911408067',
  appId: '1:496911408067:web:7e408644c50d3282bb3b76',
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const provider = new GoogleAuthProvider();
const auth = getAuth();
export const db = getFirestore(app, {
  experimentalForceLongPolling: true,
  // experimentalAutoDetectLongPolling: true,
  useFetchStreams: false,
});

export const createProgramsList = async (
  userName,
  year,
  title,
  description,
  location,
  date
) => {
  try {
    console.log('inside  create try');
    const docRef = await addDoc(collection(db, 'programs'), {
      userName,
      year,
      title,
      description,
      location,
      date,
    });
    return docRef.id;
  } catch (error) {
    console.log(error);
  } finally {
  }
};

export const getProgramsList = async () => {
  try {
    const docs = await query(collection(db, 'programs'));
    return docs;
  } catch (error) {
    console.log(error);
  }
};

// export const getProgram = async (programId) => {
//   try {
//     const doc = await addDoc(collection(db, 'programs')
//       .where('programId', '==', programId));
//     return doc.data();

//   }
//   // const programsColRef = collection(db, 'programsList');
//   // console.log('in col ', programsColRef);
//   // return addDoc(programsColRef, {
//   //   created: serverTimestamp(),
//   //   createdBy: userName,
//   //   year,
//   //   title,
//   //   description,
//   //   location,
//   //   date,
//   // });
// };

export { app, provider, auth, firebaseConfig };
